.modal-bottom-buttons {
  width: 100%;
  display: flex;
  justify-content: flex-end;
  align-items: center;
  gap: var(--spacing-2);
  margin-top: var(--spacing-8);
}

.modal-header {
  position: absolute;
  top: 0;
  right: var(--spacing-8);
  left: var(--spacing-7);
  padding-top: var(--spacing-6);
  padding-bottom: var(--spacing-7);
  background-color: var(--color-white);
  z-index: var(--z-index-modal);
  display: flex;
  align-items: center;
}

.modal-footer {
  position: sticky;
  bottom: 0;
  right: 0;
  left: 0;
  margin: 0;
  padding-bottom: var(--spacing-6);
  padding-top: var(--spacing-4);
  background-color: var(--color-white);
  z-index: var(--z-index-modal);
}
